import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";
import Loader from '../../../utils/Loader';
import { useShowLearningOutcomeQuery,useUpdateLearningOutcomeMutation,useGetCourseListQuery} from "../../../Services/api";
export default function UpdateStudent(props) {
      const notify = () => '';
    
      const {
        data: ShowLearningOutcome,
        isLoading: isGetLoading,
      } =  useShowLearningOutcomeQuery({  params:props['id']});
      const [UpdateLearningOutcome,isLoading] = useUpdateLearningOutcomeMutation();
      const getLearningOutcome= ShowLearningOutcome?.data[0];
        const defaultValues={
            element_name:getLearningOutcome?.element_name,
            course_id:getLearningOutcome?.course_id,
            element_tag:getLearningOutcome?.element_tag,
            introduction:getLearningOutcome?.introduction,
        }
        const methods = useForm({
            mode: "onChange",
            defaultValues: defaultValues, 
        });
        const {
            register,
            handleSubmit,
            reset,
            formState: { errors },
        } = methods;
        // eslint-disable-next-line react-hooks/exhaustive-deps 
        useEffect(() => {
            reset(defaultValues)
        },[getLearningOutcome]) 

    const updateOutcomeList = (values,e) => {
        const formData = new FormData();
        formData.append('course_id', values.course_id);
        formData.append('element_name', values.element_name);
        formData.append('element_tag', values.element_tag);
        formData.append('file', values.file[0]);
        formData.append('type', 'relevant_question');
        formData.append('introduction', values.introduction);
        formData.append('id', props['id']);
       
        UpdateLearningOutcome(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
   
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    if(isGetLoading) return  <Loader></Loader>
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Learning Outcome</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Update Learning Outcome</h5>
                            <form onSubmit={handleSubmit(updateOutcomeList)} >
                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                                    <div className="col-sm-10">
                                        <select  {...register("course_id", { required: true })} className="form-control">
                                        <option value="">Select Course</option>                                           
                                        {                            
                                        getCourseList?.data?.map((item) => {
                                            return (
                                                <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                                )
                                            })
                                        }
                                        </select>
                                        {errors.course_id && <span  className="text-danger">Course is required</span>}
                                
                                    </div>
                                </div>
                                
                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element Name</label>
                                    <div className="col-sm-10">
                                        <input type="name" {...register("element_name" ,{ required: true})} className="form-control" />
                                        {errors.element_name && <span  className="text-danger">Element Tag is required</span>}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element Tag</label>
                                    <div className="col-sm-10">
                                        <input type="name" {...register("element_tag" ,{ required: true})} className="form-control" />
                                        {errors.element_tag && <span  className="text-danger">Element Tag is required</span>}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Relevant Questions</label>
                                    <div className="col-sm-10">
                                        <input type="file" {...register('file')} className="form-control" />
                                        {errors.file && <span  className="text-danger">Relevant is required</span>}

                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Introduction</label>
                                    <div className="col-sm-10">
                                        <textarea rows={6} {...register("introduction" ,{ required: true})} className="form-control" >
                                        </textarea>
                                        {errors.introduction && <span  className="text-danger">Introduction is required</span>}

                                    </div>
                                </div>
                                <div className="modal-footer">
                                   
                                    {isLoading.status !='pending' ? 
                                      <>
                                       <button type="submit" className="btn btn-warning">Save changes</button>
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                      </> 
                                    :
                                    <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                    }
                                </div> 
                            </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}